export const objectToArray = (input: object | object[]): object[] =>
  Array.isArray(input) ? input : [input];
